import { useContext } from 'react';

import { ColorModeContext } from './context';

export function useColorMode() {
  const context = useContext(ColorModeContext);
  if (!context || Object.keys(context).length === 0) {
    throw new Error('useColorMode must be used within a ThemeProvider');
  }
  return context;
}
